import { Paginate, styled, Text, useResponsive } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';

interface PaginationProps {
  onPageChange: (page: number) => void;
  countParticipants: number;
  pageCount: number;
  currentPage: number;
  countLabel?: string;
}

const PaginateContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  gap: '$xs',
  height: '48px',
  bg: '$gray200',
  width: '100%',
  zIndex: '$docked',
});

const PaginateCountText = styled('p', {
  display: 'none',
  position: 'absolute',
  left: '$md',
  fontSize: '$xs',
  '@lg': { display: 'block' },
});

export function Pagination({
  countParticipants,
  pageCount,
  currentPage,
  onPageChange,
  countLabel,
}: PaginationProps) {
  const { isMobile } = useResponsive({ useOnlyAbiTokens: true });
  const { t } = useTranslate('admin');

  return (
    <PaginateContainer>
      <PaginateCountText>
        {countLabel ?? t('total')}:{' '}
        <Text as="span" css={{ ml: '$xs', fontSize: '$xs', fontWeight: 600 }}>
          {countParticipants}
        </Text>
      </PaginateCountText>

      <Paginate
        forcePage={currentPage}
        pageCount={pageCount}
        marginPagesDisplayed={isMobile ? 1 : 3}
        onPageChange={({ selected }) => onPageChange(selected)}
      />
    </PaginateContainer>
  );
}
